<template>
  <div class="table-text-preview">
    <el-popover
      placement="top-start"
      trigger="hover"
      :width="420"
      popper-class="table-text-preview__popover"
    >
      <div class="table-text-preview__full">{{ displayText }}</div>
      <div class="table-text-preview__actions">
        <el-button type="text" size="mini" @click="drawerVisible = true">查看详情</el-button>
      </div>
      <span slot="reference" class="table-text-preview__summary">{{ summaryText }}</span>
    </el-popover>
    <el-drawer
      :visible.sync="drawerVisible"
      :title="title || '详情'"
      size="38%"
      append-to-body
    >
      <div class="table-text-preview__drawer">{{ displayText }}</div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: "TableTextPreview",
  props: {
    text: {
      type: [String, Number],
      default: "",
    },
    maxLength: {
      type: Number,
      default: 20,
    },
    title: {
      type: String,
      default: "",
    },
    emptyText: {
      type: String,
      default: "-",
    },
  },
  data() {
    return {
      drawerVisible: false,
    };
  },
  computed: {
    displayText() {
      if (this.text === null || this.text === undefined || this.text === "") {
        return this.emptyText;
      }
      return String(this.text);
    },
    summaryText() {
      const source = this.displayText;
      if (source.length <= this.maxLength) {
        return source;
      }
      return `${source.slice(0, this.maxLength)}...`;
    },
  },
};
</script>
<style scoped>
.table-text-preview{
  display: inline-flex;
  width: 100%;
  align-items: center;
}
.table-text-preview__summary{
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #303133;
  cursor: pointer;
}
.table-text-preview__full{
  white-space: pre-wrap;
  line-height: 22px;
  max-height: 320px;
  overflow-y: auto;
  color: #303133;
}
.table-text-preview__actions{
  margin-top: 8px;
  text-align: right;
}
.table-text-preview__drawer{
  padding: 8px 16px 16px 16px;
  white-space: pre-wrap;
  line-height: 24px;
  color: #303133;
}
</style>
